<div class="app-main__inner">

  <!-- ========== LIST VIEW ========== -->
  <div *ngIf="view === 'list'" class="bb-list-view">
    <div class="card bb-fill-card">
      <div class="card-header d-flex align-items-center justify-content-between">
        <span class="fw-semibold"><i class="pe-7s-lock me-2 text-primary"></i>Membership Closure Reasons</span>
        <div class="d-flex align-items-center gap-2">
          <span class="badge bg-secondary">{{ records.length }} records</span>
          <button type="button" class="btn btn-primary btn-sm" (click)="addNew()">
            <i class="pe-7s-plus me-1"></i> Add New Reason
          </button>
        </div>
      </div>
      <div class="card-body p-0 bb-fill-body">
        <div class="text-center py-5" *ngIf="isListLoading">
          <div class="spinner-border text-primary"></div>
          <p class="mt-2 text-muted">Loading closure reasons...</p>
        </div>
        <vio-table-v2 *ngIf="!isListLoading" [tableData]="records" [tableConfig]="tableConfig"></vio-table-v2>
      </div>
    </div>
  </div>

  <!-- ========== FORM VIEW ========== -->
  <div *ngIf="view === 'form'" class="bb-form-view">
    <div class="bb-form-card">

      <div class="bb-form-header">
        <div class="bb-form-header__title">
          <i class="pe-7s-lock"></i>
          {{ isEditMode ? 'Edit Closure Reason' : 'New Closure Reason' }}
        </div>
        <button type="button" class="bb-form-header__back" (click)="backToList()">
          <i class="pe-7s-angle-left"></i> Back
        </button>
      </div>

      <form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
        <div class="bb-form-body">
          <div class="row g-2 align-items-end">
            <div class="col-md-7">
              <label class="form-label">Reason <span class="text-danger">*</span></label>
              <input type="text" formControlName="reasonName" class="form-control"
                     [class.is-invalid]="isFieldInvalid('reasonName')"
                     placeholder="e.g. Relocated, Not reading anymore" maxlength="100" />
              <div class="invalid-feedback">
                <span *ngIf="f['reasonName'].errors?.['required']">Reason is required.</span>
                <span *ngIf="f['reasonName'].errors?.['minlength']">Must be at least 2 characters.</span>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-check form-switch mb-2">
                <input class="form-check-input" type="checkbox" id="crActive" formControlName="isActive" />
                <label class="form-check-label" for="crActive">Active</label>
              </div>
            </div>
          </div>
          <div class="form-text">Only active reasons appear in the Close Membership dropdown. Mark a reason inactive to retire it.</div>
        </div>

        <div class="bb-form-footer">
          <div class="bb-form-footer__msg">
            <span *ngIf="errorMessage" class="text-danger"><i class="pe-7s-close-circle me-1"></i>{{ errorMessage }}</span>
            <span *ngIf="successMessage" class="text-success"><i class="pe-7s-check me-1"></i>{{ successMessage }}</span>
          </div>
          <button type="submit" class="bb-btn-save" [disabled]="isSaving">
            <span *ngIf="!isSaving"><i class="pe-7s-diskette"></i> {{ isEditMode ? 'Update' : 'Save' }}</span>
            <span *ngIf="isSaving" class="d-flex align-items-center gap-1"><span class="spinner-border spinner-border-sm"></span> Saving...</span>
          </button>
        </div>
      </form>

    </div>
  </div>

</div>
